/* tslint:disable */
/* eslint-disable */
/**
 * AllOfUs Workbench API
 * The API for the AllOfUs workbench.  Throughout, we use integer/int64 in preference to string/date-time because Swagger\'s date formatting is inconsistent between server and client. Time values are stored as milliseconds since the UNIX epoch.  Note: all requests tagged as \"cron\" must have the header X-Appengine-Cron: true, which app engine itself only sets when invoking as a cronjob. See https://cloud.google.com/appengine/docs/standard/java/config/cron#securing_urls_for_cron and o.p.w.interceptors.CronInterceptor which implements the header check. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UserDisabledEvent } from './UserDisabledEvent';
import {
    UserDisabledEventFromJSON,
    UserDisabledEventFromJSONTyped,
    UserDisabledEventToJSON,
} from './UserDisabledEvent';

/**
 * 
 * @export
 * @interface ListUserDisabledEventsResponse
 */
export interface ListUserDisabledEventsResponse {
    /**
     * 
     * @type {Array<UserDisabledEvent>}
     * @memberof ListUserDisabledEventsResponse
     */
    disabledEvents?: Array<UserDisabledEvent>;
}

/**
 * Check if a given object implements the ListUserDisabledEventsResponse interface.
 */
export function instanceOfListUserDisabledEventsResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ListUserDisabledEventsResponseFromJSON(json: any): ListUserDisabledEventsResponse {
    return ListUserDisabledEventsResponseFromJSONTyped(json, false);
}

export function ListUserDisabledEventsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListUserDisabledEventsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'disabledEvents': !exists(json, 'disabledEvents') ? undefined : ((json['disabledEvents'] as Array<any>).map(UserDisabledEventFromJSON)),
    };
}

export function ListUserDisabledEventsResponseToJSON(value?: ListUserDisabledEventsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'disabledEvents': value.disabledEvents === undefined ? undefined : ((value.disabledEvents as Array<any>).map(UserDisabledEventToJSON)),
    };
}

